<div fxLayout="column" fxLayoutGap="8px" data-testid="module-config-field-formula">
    <div fxLayout="row wrap" fxLayoutAlign="space-between center" class="cipo--gap--xs">
        <div fxLayout="row wrap" class="cipo--gap--xs">
            @if (!isDateResult()) {
                <button
                    mat-stroked-button
                    data-testid="module-config-field-formula-action-add-function"
                    [disabled]="locked() || operatorTurn() || deleteMode() || !numericFields().length"
                    (click)="addFunction()">
                    <mat-icon aria-hidden="true">functions</mat-icon>
                    {{ "modules.fieldConfig.formula.addFormula" | translate }}
                </button>
            }
            <button
                mat-stroked-button
                data-testid="module-config-field-formula-action-add-date"
                [disabled]="locked() || operatorTurn() || deleteMode() || !dateFields().length"
                (click)="addDateFunction()">
                <mat-icon aria-hidden="true">event</mat-icon>
                {{ "modules.fieldConfig.formula.addDateFormula" | translate }}
            </button>
            @if (!isDateResult()) {
                <button
                    mat-stroked-button
                    data-testid="module-config-field-formula-action-add-number"
                    [disabled]="locked() || operatorTurn() || deleteMode()"
                    (click)="addNumber()">
                    <mat-icon aria-hidden="true">pin</mat-icon>
                    {{ "modules.fieldConfig.formula.addNumber" | translate }}
                </button>
                <button
                    mat-stroked-button
                    data-testid="module-config-field-formula-action-add-operator"
                    [disabled]="locked() || !operatorTurn() || deleteMode()"
                    (click)="addOperator()">
                    <mat-icon aria-hidden="true">calculate</mat-icon>
                    {{ "modules.fieldConfig.formula.addOperator" | translate }}
                </button>
                <button
                    mat-stroked-button
                    data-testid="module-config-field-formula-action-open-parenthesis"
                    [disabled]="locked() || deleteMode() || !canOpenParenthesis()"
                    [title]="'modules.fieldConfig.formula.addOpeningParenthesis' | translate"
                    (click)="addParenthesis('(')">
                    (
                </button>
                <button
                    mat-stroked-button
                    data-testid="module-config-field-formula-action-close-parenthesis"
                    [disabled]="locked() || deleteMode() || !canCloseParenthesis()"
                    [title]="'modules.fieldConfig.formula.addClosingParenthesis' | translate"
                    (click)="addParenthesis(')')">
                    )
                </button>
            }
        </div>

        <div fxLayout="row" class="cipo--gap--xs">
            @if (deleteMode()) {
                <button
                    mat-button
                    data-testid="module-config-field-formula-action-cancel-remove"
                    (click)="cancelDelete()">
                    {{ "actions.cancel" | translate }}
                </button>
                <button
                    mat-flat-button
                    color="primary"
                    data-testid="module-config-field-formula-action-done"
                    (click)="finishDelete()">
                    {{ "modules.fieldConfig.formula.done" | translate }}
                </button>
            } @else if (tokens().length) {
                <button
                    mat-button
                    data-testid="module-config-field-formula-action-remove"
                    [disabled]="locked()"
                    (click)="enterDeleteMode()">
                    <mat-icon aria-hidden="true">backspace</mat-icon>
                    {{ "modules.fieldConfig.formula.remove" | translate }}
                </button>
            }
        </div>
    </div>

    <div
        fxLayout="row wrap"
        fxLayoutAlign="start center"
        role="group"
        class="cipo--min-height--58 cipo--gap--xs cipo--border--dashed cipo--border-radius--xs p-a-sm"
        [attr.aria-label]="'modules.fieldConfig.formula.expression' | translate">
        @if (loading()) {
            <ngx-skeleton-loader
                class="cipo--width--full"
                count="1"
                role="status"
                [attr.aria-busy]="true"
                [attr.aria-label]="'a11y.moduleConfig.loadingFormula' | translate"
                [theme]="{ width: '100%', height: '36px', margin: '0' }" />
        } @else if (!tokens().length) {
            <span class="mat-body-2 cipo-text--black-500">{{ "modules.fieldConfig.formula.empty" | translate }}</span>
        } @else {
            @for (token of tokens(); track $index; let index = $index) {
                <div
                    class="formula-token"
                    fxLayout="row wrap"
                    fxLayoutAlign="start center"
                    data-testid="module-config-field-formula-token"
                    [class.formula-token--error]="invalidIndexes().has(index)"
                    [class.formula-token--plain]="token.type === 'parenthesis'">
                    @switch (token.type) {
                        @case ("function") {
                            <button
                                mat-button
                                data-testid="module-config-field-formula-token-function"
                                [disabled]="locked() || deleteMode()"
                                [matMenuTriggerFor]="functionMenu"
                                [matMenuTriggerData]="{ index: index }">
                                {{ functionLabel(token.functionKey) }}
                                <mat-icon iconPositionEnd aria-hidden="true">arrow_drop_down</mat-icon>
                            </button>
                            <ng-container
                                [ngTemplateOutlet]="fieldPicker"
                                [ngTemplateOutletContext]="{
                                    index: index,
                                    slot: 'field',
                                    token: token,
                                    field: token.field,
                                    placeholder: 'modules.fieldConfig.formula.selectColumn',
                                }" />
                        }
                        @case ("date") {
                            <span
                                class="cipo--text-weight--medium p-x-sm"
                                [class.cipo-text--black-400]="locked() || deleteMode()"
                                [title]="token.name">
                                {{ token.name }}
                            </span>
                            <button
                                mat-button
                                data-testid="module-config-field-formula-token-date-part"
                                [disabled]="locked() || deleteMode()"
                                [matMenuTriggerFor]="datePartMenu"
                                [matMenuTriggerData]="{ index: index }">
                                {{ "modules.fieldConfig.formula.dateParts." + token.datePart | translate }}
                                <mat-icon iconPositionEnd aria-hidden="true">arrow_drop_down</mat-icon>
                            </button>
                            @if (token.secondKind === "number") {
                                <button
                                    mat-icon-button
                                    data-testid="module-config-field-formula-token-swap"
                                    [disabled]="locked() || deleteMode()"
                                    [title]="
                                        (token.useSecondField
                                            ? 'modules.fieldConfig.formula.useNumberInput'
                                            : 'modules.fieldConfig.formula.useNumericField'
                                        ) | translate
                                    "
                                    (click)="toggleSecondParameter(index)">
                                    <mat-icon aria-hidden="true">swap_horiz</mat-icon>
                                </button>
                            }
                            @if (token.secondKind === "date" || token.useSecondField) {
                                <ng-container
                                    [ngTemplateOutlet]="fieldPicker"
                                    [ngTemplateOutletContext]="{
                                        index: index,
                                        slot: 'second',
                                        token: token,
                                        field: token.secondField,
                                        placeholder:
                                            token.secondKind === 'date'
                                                ? 'modules.fieldConfig.formula.selectStartDate'
                                                : 'modules.fieldConfig.formula.selectNumber',
                                    }" />
                            } @else {
                                <mat-form-field class="cipo-input cipo--width--100" subscriptSizing="dynamic">
                                    <input
                                        matInput
                                        type="number"
                                        min="0"
                                        data-testid="module-config-field-formula-token-second-number"
                                        [attr.aria-label]="'modules.fieldConfig.formula.number' | translate"
                                        [placeholder]="'modules.fieldConfig.formula.number' | translate"
                                        [disabled]="locked() || deleteMode()"
                                        [value]="token.secondNumber ?? ''"
                                        (input)="setSecondNumber(index, $any($event.target).value)" />
                                </mat-form-field>
                            }
                            <ng-container
                                [ngTemplateOutlet]="fieldPicker"
                                [ngTemplateOutletContext]="{
                                    index: index,
                                    slot: 'third',
                                    token: token,
                                    field: token.thirdField,
                                    placeholder:
                                        token.secondKind === 'date'
                                            ? 'modules.fieldConfig.formula.selectEndDate'
                                            : 'modules.fieldConfig.formula.selectDate',
                                }" />
                        }
                        @case ("operator") {
                            <button
                                mat-button
                                data-testid="module-config-field-formula-token-operator"
                                [disabled]="locked() || deleteMode()"
                                [attr.aria-label]="'modules.fieldConfig.formula.operator' | translate"
                                [matMenuTriggerFor]="operatorMenu"
                                [matMenuTriggerData]="{ index: index }">
                                {{ operatorLabel(token.value) }}
                                <mat-icon iconPositionEnd aria-hidden="true">arrow_drop_down</mat-icon>
                            </button>
                        }
                        @case ("number") {
                            <mat-form-field class="cipo-input cipo--width--100" subscriptSizing="dynamic">
                                <input
                                    matInput
                                    type="number"
                                    min="0"
                                    data-testid="module-config-field-formula-token-number"
                                    [attr.aria-label]="'modules.fieldConfig.formula.number' | translate"
                                    [placeholder]="'modules.fieldConfig.formula.number' | translate"
                                    [disabled]="locked() || deleteMode()"
                                    [value]="token.value"
                                    (input)="setNumber(index, $any($event.target).value)" />
                            </mat-form-field>
                        }
                        @case ("parenthesis") {
                            <span class="cipo--text-weight--bold p-x-xs">{{ token.value }}</span>
                        }
                    }

                    @if (deleteMode()) {
                        <button
                            mat-icon-button
                            color="warn"
                            data-testid="module-config-field-formula-token-remove"
                            [title]="'actions.delete' | translate"
                            (click)="removeToken(index)">
                            <mat-icon aria-hidden="true">close</mat-icon>
                        </button>
                    }
                </div>
            }
        }
    </div>

    @if (negativeNumber()) {
        <span class="mat-caption cipo-text--warn-900">
            {{ "modules.fieldConfig.formula.negativeNumber" | translate }}
        </span>
    }
    @if (disabled()) {
        <span class="mat-caption cipo-text--black-500" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
            <mat-icon class="material-icons-outlined" inline aria-hidden="true">info</mat-icon>
            {{ "modules.fieldConfig.formula.onlyOnDefault" | translate }}
        </span>
    }
</div>

<ng-template
    #fieldPicker
    let-index="index"
    let-slot="slot"
    let-token="token"
    let-field="field"
    let-placeholder="placeholder">
    <button
        mat-button
        data-testid="module-config-field-formula-token-field"
        [class.cipo-text--warn-900]="invalidIndexes().has(index)"
        [disabled]="locked() || deleteMode()"
        [title]="field?.value || (placeholder | translate)"
        [matMenuTriggerFor]="fieldMenu"
        [matMenuTriggerData]="{ index: index, slot: slot, token: token }">
        {{ field?.value || (placeholder | translate) }}
        <mat-icon iconPositionEnd aria-hidden="true">arrow_drop_down</mat-icon>
    </button>
</ng-template>

<mat-menu #functionMenu="matMenu">
    <ng-template matMenuContent let-index="index">
        @for (fn of functions; track fn.key) {
            <button
                mat-menu-item
                data-testid="module-config-field-formula-function-option"
                (click)="setFunction(index, fn.key)">
                {{ fn.label }}
            </button>
        }
    </ng-template>
</mat-menu>

<mat-menu #datePartMenu="matMenu">
    <ng-template matMenuContent let-index="index">
        @for (part of dateParts; track part) {
            <button
                mat-menu-item
                data-testid="module-config-field-formula-date-part-option"
                (click)="setDatePart(index, part)">
                {{ "modules.fieldConfig.formula.dateParts." + part | translate }}
            </button>
        }
    </ng-template>
</mat-menu>

<mat-menu #operatorMenu="matMenu">
    <ng-template matMenuContent let-index="index">
        @for (operator of operatorsAt(index); track operator.value) {
            <button
                mat-menu-item
                data-testid="module-config-field-formula-operator-option"
                [attr.data-operator]="operator.value"
                (click)="setOperator(index, operator.value)">
                {{ operator.label }}
            </button>
        }
    </ng-template>
</mat-menu>

<mat-menu #fieldMenu="matMenu" (closed)="fieldQuery.set('')">
    <ng-template matMenuContent let-index="index" let-slot="slot" let-token="token">
        <div
            class="p-x-sm p-t-sm"
            role="presentation"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()">
            <mat-form-field class="cipo-input cipo--width--full" subscriptSizing="dynamic">
                <input
                    matInput
                    data-testid="module-config-field-formula-field-search"
                    [attr.aria-label]="'general.search' | translate"
                    [placeholder]="'general.search' | translate"
                    [value]="fieldQuery()"
                    (input)="fieldQuery.set($any($event.target).value)" />
                <mat-icon matSuffix aria-hidden="true">search</mat-icon>
            </mat-form-field>
        </div>
        @for (option of fieldsFor(slot, token); track option.key) {
            <button
                mat-menu-item
                data-testid="module-config-field-formula-field-option"
                [attr.data-field-key]="option.key"
                [title]="option.relations || option.value"
                (click)="setField(index, slot, option)">
                {{ option.value }}
            </button>
        } @empty {
            <p class="mat-body-2 cipo-text--black-500 p-x-md">{{ "notFound.nothingFound" | translate }}</p>
        }
    </ng-template>
</mat-menu>
